function verifyCpf(strCPF) {
  strCPF = strCPF.replace(/[^\d]+/g, '');
  let Soma = 0;
  let Resto;
  let i;
  let verificacao = true;
  
  if (strCPF.length === 11) {
    if (/^(\d)\1{10}$/.test(strCPF)) return false;

    for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto === 10) || (Resto === 11)) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(9, 10))) return false;
    
    Soma = 0;
    for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto === 10) || (Resto === 11)) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(10, 11))) return false;
  } else {
    return false;
  }
  return verificacao;
}

function verifyCnpj(cnpj) {
  cnpj = cnpj.replace(/[^A-Za-z0-9]/g, '').toUpperCase();

  if (cnpj === '' || cnpj.length !== 14) return false;

  const invalidosConhecidos = [
      "00000000000000", "11111111111111", "22222222222222", 
      "33333333333333", "44444444444444", "55555555555555", 
      "66666666666666", "77777777777777", "88888888888888", "99999999999999"
  ];
  if (invalidosConhecidos.includes(cnpj)) return false;

  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  
  if (isNaN(Number(digitos))) return false;

  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += (numeros.charCodeAt(tamanho - i) - 48) * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado !== parseInt(digitos.charAt(0))) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += (numeros.charCodeAt(tamanho - i) - 48) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado !== parseInt(digitos.charAt(1))) return false;

  return true;
}

export const formatCPF = cpfCnpj => {
  // Remove pontuação, mas mantém letras e números
  let strClean = cpfCnpj.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  
  if (strClean.length > 11) {
    // Máscara dinâmica para CNPJ Alfanumérico
    strClean = strClean.replace(/^([A-Z0-9]{2})([A-Z0-9])/, "$1.$2");
    strClean = strClean.replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, "$1.$2.$3");
    strClean = strClean.replace(/\.([A-Z0-9]{3})([A-Z0-9])/, ".$1/$2");
    strClean = strClean.replace(/([A-Z0-9]{4})([0-9]{1,2})$/, "$1-$2"); 
  } else {
    // Máscara dinâmica para CPF
    strClean = strClean.replace(/\D/g, '');
    strClean = strClean.replace(/(\d{3})(\d)/, "$1.$2");
    strClean = strClean.replace(/(\d{3})\.(\d{3})(\d)/, "$1.$2.$3");
    strClean = strClean.replace(/(\d{3})\.(\d{3})\.(\d{3})(\d{1,2})$/, "$1.$2.$3-$4");
  }
  return strClean;
}

export default function verifyCpfCnpj(str) {
  let isValid = false;
  let error = '';
  
  const strClean = (str || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  
  const hasLetters = /[A-Z]/.test(strClean);

  if (strClean.length === 0) {
    isValid = true;
  } else if (strClean.length <= 11 && !hasLetters) {
    isValid = verifyCpf(strClean);
    error = isValid ? '' : 'CPF Inválido';
  } else {
    isValid = verifyCnpj(strClean);
    error = isValid ? '' : 'CNPJ Inválido';
  }

  return {
    isValid: isValid,
    error: error,
    cpfCnpjFormat: formatCPF(str),
    cpfCnpj: strClean
  }
}